import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'priorityClass',
  pure: true // This makes it a pure pipe for better performance
})
export class PriorityClassPipe implements PipeTransform {
  transform(priority?: string): string {
    if (!priority) {
      return '';
    }
    
    switch (priority.toLowerCase()) {
      case 'high':
        return 'priority-high';
      case 'medium':
        return 'priority-medium';
      case 'low':
        return 'priority-low';
      default:
        return '';
    }
  }
}
